import { searchCardsStoreName } from '../../components/Shared/Constants/Browse/BrowseConstants';

const initialState = {
  nationwideListings: [],
  nationwideListingsNext: [],
  allListingsCount: 0,
  searchListings: [],
  searchListingsPagination: {},
  searchMapBubbles: [],
  listingMarkers: [],
  shouldPerformSearch: false,
  shouldCancelSearchAlert: false,
  shouldTriggerSearchAlert: false,
  isSearchMapLoading: false,
  activeListing: {},
};
const propertiesToPreserve = [
  'shouldPerformSearch',
  'shouldCancelSearchAlert',
  'shouldTriggerSearchAlert',
  'isSearchMapLoading',
];

const getPreservedState = state => {
  return propertiesToPreserve.reduce((acc, key) => {
    if (key in state) acc[key] = state[key];
    return acc;
  }, {});
};

const reducerName = searchCardsStoreName;

const updateAction = (state, action) => {
  const updatedState = { ...state };

  Object.keys(action.updatedResult).forEach(key => {
    if (key in initialState) {
      updatedState[key] = action.updatedResult[key];
    }
  });

  return updatedState;
};
const searchCardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'InsertListings'.concat(reducerName):
      return {
        ...state,
        searchListings: state.searchListings.concat(
          action.payload.results.filter(
            incoming =>
              state.searchListings.some(
                current => current.id === incoming.id,
              ) === false,
          ),
        ),
        searchListingsPagination: action.payload?.pagination ?? false,
      };
    case 'InsertNationwides'.concat(reducerName):
      return {
        ...state,
        nationwideListings: state.nationwideListings.concat(
          action.payload.nationwideListings.filter(
            incoming =>
              state.nationwideListings.some(
                current => current.id === incoming.id,
              ) === false,
          ),
        ),
        next: action.payload?.next ?? false,
      };
    case 'Update'.concat(reducerName):
      return updateAction(state, action);
    case 'isMapLoading'.concat(reducerName):
      return {
        ...state,
        isSearchMapLoading: action.payload,
      };
    case 'Clear'.concat(reducerName):
      return {
        ...initialState,
        ...getPreservedState(state),
      };
    case 'ShouldPerformSearch'.concat(reducerName):
      return {
        ...state,
        shouldPerformSearch: action.payload,
      };
    default:
      return state;
  }
};

export default searchCardsReducer;
